import { CardBackground, LoadingSpinner } from 'components/ui';

export const InitialLoadingPlaceholder = () => {
  return (
    <div className="mt-8">
      <div className="flex px-5 mb-2 space-x-64">
        <p className="font-bold leading-4 text-segments-13px">Products</p>
        <p className="pl-3 font-bold leading-4 text-segments-13px">Relations</p>
      </div>
      <CardBackground>
        <div className="p-11 h[900px]">
          <div className="grid h-full place-items-center">
            <LoadingSpinner className="w-[64px] h-[64px] text-segments-accent-color-orange" />
          </div>
        </div>
      </CardBackground>
    </div>
  );
};
